import { Button, Icon, Popover, Typography } from '@equinor/eds-core-react'
import { close } from '@equinor/eds-icons'
import styled from 'styled-components'

interface Props {
    title?: string
    content?: string
    open: boolean
    anchorEl: HTMLDivElement | null
    onClose?: () => void
}

const PopoverDialog = (props: Props) => {
    return (
        <Popover open={props.open} anchorEl={props.anchorEl} onClose={() => props.onClose?.()}>
            <Popover.Header>
                <Popover.Title>{props.title}</Popover.Title>
                <StyledButton
                    style={{
                        height: '32px',
                        width: '32px',
                    }}
                    variant="ghost_icon"
                    aria-label="Close popover"
                    onClick={() => props.onClose?.()}
                >
                    <Icon data={close} size={24} />
                </StyledButton>
            </Popover.Header>
            <Popover.Content>
                <StyledPopoverContent variant="body_short">{props.content}</StyledPopoverContent>
            </Popover.Content>
        </Popover>
    )
}

const StyledPopoverContent = styled(Typography)`
    max-width: 280px;
    white-space: pre-line;
    overflow-wrap: anywhere;
`

const StyledButton = styled(Button)`
    background: transparent;
    border: 0;
    padding: 0;
    box-shadow: none;

    &:hover {
        background: #eaeaea;
    }

    &:active {
        background: #dcdcdc;
    }

    &:focus,
    &:focus-visible {
        background: #eaeaea;
        outline: none;
        box-shadow: none;
    }
`

export default PopoverDialog
